module.exports = __webpack_public_path__ + "static/img/34_pro.97900ee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rz/34_pro.jpg
// module id = Z63w
// module chunks = 0